import moment from 'moment'
import React from 'react'
import Footer from './Footer'

export default function FooterInner() {
    return (
        <Footer />
    )
}
